module.exports = __webpack_public_path__ + "media/webfonts/Noto_Sans_JP/NotoSansJP-Light-1b2ce4fd33d26f3d812189f406c1793e.otf";